export const UseGetPermission = () => {
  const permission = JSON.parse(localStorage.getItem("permission"));
  const validatorPermission = permission === "validator";
  const dataEntryOperatorPermission = permission === "dataentry";

  return { validatorPermission, dataEntryOperatorPermission };
};
